<template>
  <li class="mTable-cell mTable-cell-medium" :style="{width: width}">
    <div class="mTable-cell-wrap">
      <span class="mTable-txt"><slot></slot></span>
    </div>
  </li>
</template>
<script>
  export default {
    name: 'grid-table-th',
    props: {
      width: {
        type: String,
        default: '160px'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid-menu/grid-table-th.vue